import i18n from '../../locales/index'
/* eslint-disable */
import { genBasicStore } from '../vuex';
import assign from 'lodash/assign';
import axios from 'axios';
import { Message } from 'view-design'

const store = genBasicStore('desk_partition');

assign(store.actions, {
  async update ({ commit }, params) {
    const { ...others } = params;
    params.discount = +params.discount;
    params.upgrade_standard = +params.upgrade_standard;
    const response = await axios.put(`desk_partitions/${params.id}`, others)
    commit('updateRecordInRecords', response.data)
    Message.success(i18n.t('store_modules_ai_1312'))
  },
  async create ({ commit }, options) {
    const { ...params } = options;
    params.discount = +params.discount;
    params.upgrade_standard = +params.upgrade_standard;
    const response = await axios.post('desk_partitions', params)
    commit('setRecord', response.data);
    commit('addRecordInRecords', response.data)
    Message.success(i18n.t('pages_combo_index_287'))
  },
})

export default store;